import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { Platform } from '@ionic/angular';

import { environment } from '../../../environments/environment';
import { QrcodeService } from '../../services/qrcode.service';

@Component({
  selector: 'app-scanner',
  templateUrl: './scanner.page.html',
  styleUrls: ['./scanner.page.scss'],
})

export class ScannerPage {

  //public web: boolean
  public isWebPlatform: boolean;

  constructor(
    private qrcodeService: QrcodeService,
    private router: Router,
    platform: Platform
  ) {
    this.isWebPlatform  = !(platform.is('android') || platform.is('ios')) || platform.is('mobileweb')
  }

  ionViewDidEnter() {
    this.qrcodeService.scan({
      useNativePlugin: !this.isWebPlatform,
      side: 'back',
      validation: (text: string) => text.includes(environment.qrcodeConfigValidationLink)
    }).pipe(
      take(1)
    ).subscribe({
      next: text => {
        const route = text.replace(environment.qrcodeConfigValidationLink, '');
        this.router.navigateByUrl(route);
      },
      error: err => {
        console.error('Erro ao escanear o QR Code:', err);
      }
    });
  }

}
